import React from "react";
import { Link } from "react-router-dom";
import {  OverlayTrigger } from "react-bootstrap";
export const TournamentEventIdFormatter = (data) => { 
    console.log(data)
    if (data === undefined || data === null || data === "")
     { return "-";}
    else{
        return   <Link to={`/tournaments/gamerji/view/${data}`}><span>{data}</span></Link>
        
        
        
        
        
        
        
        
       // <Link to={`/tournaments/gamerji/view/${data}`} style={{ color: '#007bff', fontWeight: 600}} target="_blank">{data}</Link>
        
        // return data;

    }
  };   

